export interface ParsedTrackTitle {
  track: string;
  artist?: string;
  album?: string;
}

// Parses the common upload format "{artist} - {track} [{album}]".
// The album bracket only counts at the very end of the title; the
// artist/track split happens on the FIRST dash so track names may
// contain further dashes.
export function parseTrackTitle(title: string): ParsedTrackTitle {
  let rest = title.trim();
  let album: string | undefined;

  const albumMatch = rest.match(/\[([^\][]+)\]\s*$/);
  if (albumMatch) {
    album = albumMatch[1].trim();
    rest = rest.slice(0, albumMatch.index).trim();
  }

  const separatorMatch = rest.match(/\s+[-–—]\s+/);
  if (!separatorMatch || separatorMatch.index === undefined) {
    return { track: rest, ...(album ? { album } : {}) };
  }

  const artist = rest.slice(0, separatorMatch.index).trim();
  const track = rest.slice(separatorMatch.index + separatorMatch[0].length).trim();

  return {
    ...(artist ? { artist } : {}),
    track,
    ...(album ? { album } : {}),
  };
}
